// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION: any = {
    "dirty": true,
    "raw": "v1.2.6-16-g1605545-dirty",
    "hash": "g1605545",
    "distance": 16,
    "tag": "v1.2.6",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v1.2.6",
        "major": 1,
        "minor": 2,
        "patch": 6,
        "prerelease": [],
        "build": [],
        "version": "1.2.6"
    },
    "suffix": "16-g1605545-dirty",
    "semverString": "1.2.6+16.g1605545",
    "version": "0.0.0"
};
/* tslint:enable */
